import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_INITIAL_STATE = {
    data: null,
    loading: false,
    error: null,
    objectAdded: false,
    objectUpdated: false,
    objectDeleted: false,
}

const reducers = (storeName, extraActions, initialState) => {
    const reducers = {}
    reducers[`${storeName}GetObjectAction`] = (state) => {
        state.data = null
        state.error = null
        state.loading = true
    }
    reducers[`${storeName}SetObjectAction`] = (state, action) => {
        state.data = action.payload
        state.loading = false
        state.error = null
        state.objectUpdated = action.payload?.objectUpdated
        state.objectDeleted = action.payload?.objectDeleted
        state.objectAdded = action.payload?.objectAdded
    }
    reducers[`${storeName}UpdateObjectAction`] = (state, action) => {
        state.error = null
        state.loading = true
    }
    reducers[`${storeName}AddObjectAction`] = (state, action) => {
        state.error = null
        state.loading = true
    }
    reducers[`${storeName}DeleteObjectAction`] = (state, action) => {
        state.error = null
        state.loading = true
    }
    reducers[`${storeName}ObjectErrorAction`] = (state, action) => {
        state.data = null
        state.error = action.payload
        state.loading = false
    }
    reducers[`${storeName}ObjectResetStateAction`] = () => initialState
    if (extraActions) {
        for (const index in extraActions) {
            const extraAction = extraActions[index]
            reducers[`${storeName}${extraAction.name}`] = extraAction.reducer
        }
    }
    return reducers
}

export const createObjectCRUDSlice = (
    storeName,
    extraActions,
    initialState = DEFAULT_INITIAL_STATE,
) => createSlice({
    name: storeName,
    initialState: initialState,
    reducers: reducers(storeName, extraActions, initialState)
})
